import PropTypes from "prop-types"

export const UI_CONSTRAINT = PropTypes.shape({
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.object]).isRequired,
  unit: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  step: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  selected: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.object]),
  secondField: PropTypes.func,
  secondHelperText: PropTypes.string,
})
